import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { Alert } from '~/components';

type Props = ComponentPropsWithRef<'div'> & {
  description: string;
};

export const PeppolForwardingWarning = ({ description, ...delegated }: Props) => {
  const { data: user } = useUser();
  const { t } = useTranslation(['settings']);

  if (user.peppol.id === null) return null;

  return (
    <Alert {...delegated} announce={false} icon="Peppol" status="warning" title={t('settings:integrations.forwarding.peppol.title')}>
      {description}
    </Alert>
  );
};
